import * as bootstrap from 'bootstrap';

var $ = jQuery.noConflict();

// Carousel init
if ($('body').hasClass('home')) {
  var carousel = document.getElementById('carouselHero');

  carousel.addEventListener('slide.bs.carousel', function (event) {
    var current = event.relatedTarget;
    document.getElementById('carousel_captions').innerHTML = current.getElementsByClassName('carousel_captions')[0].innerHTML;
    //document.getElementById('carousel_next_event_bg').innerHTML = current.getElementsByClassName('carousel_next_event_bg')[0].innerHTML;
  });
}

if ($('body').hasClass('page-template-salle')) {
  var carouselVenue = document.getElementById('carouselVenue');
}

if ($('body').hasClass('single-agenda')) {
  var carouselShow = document.getElementById('carouselShow');
}

// Toggle aria-expanded on Nav button
$( ".primary-header__inner--nav button" ).click(function() {  
  $(this).attr('aria-expanded', function (i, attr) {
     return attr == 'true' ? 'false' : 'true'
  });
});


// GSAP nav animation on menu toggle
var tl = gsap.timeline({ paused: true });

function openNav() {
  animateOpenNav();
  var navBtn = document.getElementById("navToggler");
  navBtn.onclick = function (e) {
    // Toggle reversed to it's opposite value
    tl.reversed(!tl.reversed());
    // Use the toggle method in the classList API
    navBtn.classList.toggle("active");
  };
}

function animateOpenNav() {
  var mobileNav = document.getElementById("menu-menu-principal-fr");
  tl.to(mobileNav, {
    duration: 0,
    ease: "power3.out",
  }).to("li.menu-item", {
    opacity: 1,
    duration: .5,
    stagger: {
      // wrap advanced options in an object
      each: 0.45,
      ease: "power1.in"
    }
  })
  .reverse(); // Finally reverse the timeline. reversed() is true
}

// init
openNav();

// Sticking class on scroll
const primaryHeader = document.querySelector(".primary-header");
const scrollWatcher = document.createElement("div");

scrollWatcher.setAttribute("data-scroll-watcher", "");
primaryHeader.before(scrollWatcher);

const navObserver = new IntersectionObserver(
  (entries) => {
    primaryHeader.classList.toggle("sticking", !entries[0].isIntersecting);
  },
  { rootMargin: "50px 0px 0px 0px" }
);

navObserver.observe(scrollWatcher);